/**
 * Stacking for creator subscription upgrade flow.
 * Workshop overlays historically used ~99999999 — keep these above that.
 */
export const SUBSCRIPTION_MODAL_Z_INDEX = 100000000;
export const PLAN_PAYMENT_MODAL_Z_INDEX = SUBSCRIPTION_MODAL_Z_INDEX + 10;
export const ADD_CARD_MODAL_Z_INDEX = PLAN_PAYMENT_MODAL_Z_INDEX + 10;
